import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2517e35c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "order-check" }, "单据查询", -1))
const _hoisted_2 = {
  key: 0,
  class: "mini-program-block"
}
const _hoisted_3 = {
  key: 1,
  class: "scan-qrcode-wrap"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-text" }, "请使用手机微信扫描二维码访问", -1))
const _hoisted_5 = { class: "scan-qrcode" }
const _hoisted_6 = ["src"]

import { useStore } from 'vuex'
import { getEntryInfo } from '@/utils'
import { useRoute, useRouter } from 'vue-router'
import { showConfirmModal } from '@/utils/tools'
import { Ref, ref, onActivated, computed } from 'vue'
import { usePlatformInfo } from '@/compositions/common'
import type { MalfunctionRepairDeviceItem } from '@/types/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import { MalfunctionRepairSelectedDevicesStorage } from '@/storage/malfunction-repair'
import appHost, { isAndrod, isApp, isAgriApp, isXagarApp } from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import DevicesHeader from './components/devices-header.vue'
import FaultDeviceList from './components/fault-device-list.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import { MalfunctionRepairDeviceTypeStorage } from '@/storage/malfunction-repair'
import normalQrcodeDevice from '@/assets/service/page-devices-qrcode.png'
import normalQrcodeDeviceCar from '@/assets/service/page-devices-qrcode-car.png'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'malfunction-repair-devices',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const $store = useStore()
const from = $route.query.from as string
const {
  clearFormData,
  getSubmitOrderSuccessGuid,
  removeFaultFormKeepAlive,
  removeNetworkListKeepAlive,
} = useMalfunctionRepairStore()
const { isLandscape, isSrc4Device, isTableDevice } = usePlatformInfo()
const queryDataDeviceSnMap: Ref<Record<string, boolean>> = ref({})
const selectedDevices: Ref<MalfunctionRepairDeviceItem[]> = ref([])
const scanDevice: Ref<null | MalfunctionRepairDeviceItem> = ref(null)

const qrcodeUrl = computed(() => {
  console.log('isXagarApp', isXagarApp)
  return isXagarApp ? normalQrcodeDeviceCar : normalQrcodeDevice
})
const isMiniProgram = computed(() => {
  return $store.getters.isMiniProgram
})
const headeTitle = computed(() => {
  return isLandscape.value ? '故障报修' : '选择报修的设备'
})
// 设置对应的device_type
function setDeviceTypeHandle() {
  if ($route.query.device_type) {
    console.log('setDeviceTypeHandle', $route.query.device_type)
    MalfunctionRepairDeviceTypeStorage.set($route.query.device_type)
  }
}
setDeviceTypeHandle()
function onLeftClick(): void {
  console.log('form', from)
  if (from) {
    $router.go(-1)
  } else {
    appHost.goAppBack()
  }
}
function onRightClick() {
  // 农服端查看单据记录，小程序没有
  // if (isSrc4Device.value) {
  //   return
  // }
  $router.push({
    name: 'malfunction-repair-order-list',
  })
}
function getSelectedDevices(list: MalfunctionRepairDeviceItem[]) {
  selectedDevices.value = list
}
function deviceSnMapChange(data: Record<string, boolean>) {
  queryDataDeviceSnMap.value = data
}
function scanHandle(data: MalfunctionRepairDeviceItem) {
  scanDevice.value = data
}
function judgeH5PlatformCanSubmit() {
  let bool = true
  const { platform, debug } = getEntryInfo()

  // 禁止非农服h5与小程序pc端提单
  if (isMiniProgram.value) {
    // 禁止pc端的提单
    if (platform === 'windows' || platform === 'mac') {
      // windows桌面端(win phone的值会是什么？)与mac桌面端禁止提单
      bool = false
    }
  } else if (!isApp && !debug) {
    // 如果不是小程序与app,并且不是debug模式下,不允许提单
    bool = false
  }
  return bool
}
function showUnUseModal(message: string) {
  showConfirmModal({
    title: '提示',
    message: message,
    confirmButtonText: '知道了',
    className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
    showCancelButton: false,
  })
}
async function nextHandle() {
  // if (!judgeH5PlatformCanSubmit()) {
  //   showConfirmModal({
  //     title: '提示',
  //     message: '当前平台不允许提单，请使用农服app或手机版小程序提单',
  //     confirmButtonText: '知道了',
  //     className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
  //     showCancelButton: false,
  //   })
  //   return
  // }

  // 如果是安卓的农服，由于提单需要限制不能使用相册，所以需要最新版本的农服支持
  // 如果是模块测试包， 版本号返回1
  // 如果是完整包，需要版本号大于等于615
  let canNext = true
  if (isAndrod && isAgriApp) {
    // 农服需要校验版本
    // 农场和自驾仪由于是新的不校验
    let version: string | number = await appHost.getNFAppVersion()
    version = Number(version)
    canNext = version === 1 || version >= 615
  }

  if (canNext) {
    // 测试包版本为1时能使用
    // 正式包版本大于等于615时能使用
    // 不能使用时提示用户升级
    MalfunctionRepairSelectedDevicesStorage.set(selectedDevices.value)
    $router.push({
      name: 'malfunction-repair-fault-form',
    })
  } else {
    showUnUseModal('当前极飞农服版本不支持提单，请升级后再进行提单')
    // showConfirmModal({
    //   title: '提示',
    //   message: '当前极飞农服版本不支持提单，请升级后再进行提单',
    //   confirmButtonText: '知道了',
    //   className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
    //   showCancelButton: false,
    // })
  }
}

onActivated(() => {
  clearFormData()
  removeFaultFormKeepAlive()
  removeNetworkListKeepAlive()

  const guid = getSubmitOrderSuccessGuid()
  if (guid) {
    $router.push({
      name: 'malfunction-repair-fault-submit-success',
      query: {
        guid,
      },
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: _unref(headeTitle),
      rightUseSlot: "",
      isReturnLeftEvent: "",
      onLeftClick: onLeftClick,
      onRightClick: onRightClick,
      leftArrowShow: !_unref(isTableDevice)
    }, {
      right: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["title", "leftArrowShow"]),
    (_unref(isMiniProgram))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(isSrc4Device))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "qrcode-img",
              src: _unref(qrcodeUrl),
              alt: "故障报修"
            }, null, 8, _hoisted_6)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(DevicesHeader, {
            onScan: scanHandle,
            queryDataDeviceSnMap: queryDataDeviceSnMap.value
          }, null, 8, ["queryDataDeviceSnMap"]),
          _createVNode(FaultDeviceList, {
            onChange: getSelectedDevices,
            onDeviceSnMapChange: deviceSnMapChange,
            scanDevice: scanDevice.value
          }, null, 8, ["scanDevice"]),
          _createVNode(CommonFooterNextButton, {
            onClick: nextHandle,
            disabled: selectedDevices.value.length === 0
          }, null, 8, ["disabled"])
        ], 64))
  ], 64))
}
}

})